import { render, staticRenderFns } from "./merchant-account-edit-main.container.vue?vue&type=template&id=2cc4351a&scoped=true&lang=pug"
import script from "./merchant-account-edit-main.container.vue?vue&type=script&lang=ts"
export * from "./merchant-account-edit-main.container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc4351a",
  null
  
)

export default component.exports